import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "api/sso/";

// 获取继教平台发起维普 SSO 跳转地址
export const ssoRedirect = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "wipu/redirect", {
           data: _params,
           method: "GET",
         });
       };




// WEBPACK FOOTER //
// ./src/fetch/api/sso.js